import { useLocation as useRouterLocation } from 'react-router';
export const useLocation = () => {
    const location = useRouterLocation();
    return location;
};
